export default __webpack_public_path__ + "appstore-b.png";